// Temperature: canonical storage is always Celsius (backend). Display can be °F (default) or °C.
export const TEMP_SENSOR_KEYS = ["wbgt"];
export const isTempSensor = (key) => TEMP_SENSOR_KEYS.includes(key);

export const cToF = (c) => (c * 9) / 5 + 32;
export const fToC = (f) => ((f - 32) * 5) / 9;
export const roundTemp = (v) => Math.round(v * 10) / 10;

export const tempSymbol = (unit) => (unit === "C" ? "°C" : "°F");

// Celsius (stored) -> displayed number in the chosen unit
export const toDisplayTemp = (celsius, unit) => (unit === "C" ? celsius : cToF(celsius));
// Displayed number in chosen unit -> Celsius (for storage)
export const fromDisplayTemp = (value, unit) => (unit === "C" ? value : fToC(value));
